import OapImmersiveParallax from './code/Scripts/components/OapImmersiveParallax.vue';

export default {
  components: {
    OapImmersiveParallax,
  },
};
